import Vue from 'vue';
import VueRouter from 'vue-router';
import Polyfills from './modules/polyfills.js';
import CountrySelectorFull from './components/CountrySelectorFull.vue';
import Feedback from './components/Feedback.vue';
import MainPage from './components/Main.vue';
import Destination from './components/Destination.vue';
import Detalii from './components/Detalii.vue';
import DetaliiTip from './components/DetaliiTip.vue';
import countries from './modules/countries.js';
import questions from './modules/questions.js';
import travelTips from './modules/travel-tips.js';
import TarifeStandard from './components/TarifeStandard.vue';
import H from './modules/helpers';
import Header from './components/Header.vue';
import Footer from './components/Footer.vue';
import VueMeta from 'vue-meta';
import countriesZone from './modules/zones.js';

Vue.use(VueMeta);

Polyfills();

// START: Add clean names to countries (no diacritics) - URL fix

countries.forEach((country) => {
    country.nameClean = H.removeAccents(country.name.toLowerCase().replace(/\s/g, '-'));
});

// END: clean names to countries

const routes = [
    { path: '/index.html', redirect: { name: 'main' } },
    { path: '*', redirect: { name: 'main' } },
    { path: '/', name: 'main', component: MainPage },
    {
        path: '/destinatie/:country/:service/:travelTime',
        name: 'destinatie',
        component: Destination,
    },
    {
        path: '/intrebari-frecvente/:questionName',
        name: 'faq',
        component: Detalii,
    },
    {
        path: '/sfaturi-de-calatorie/:country/:offerType/:travelTime/:tipName',
        name: 'travel-tips',
        component: DetaliiTip,
    },
    {
        path: '/tarife-standard',
        name: 'tarife-standard',
        component: TarifeStandard,
    },
];

let eventBus = new Vue();

window.eventBus = eventBus;

const router = new VueRouter({
    mode: 'history',
    base: '/roaming/',
    routes,
});

Vue.use(VueRouter);

Vue.component('Feedback', Feedback);

router.beforeEach((to, from, next) => {
    // Redirect if fullPath begins with a hash (ignore hashes later in path)
    if (to.fullPath.substr(0, 2) === '/#') {
        const path = to.fullPath.substr(2);
        next(path);
        return;
    }
    next();
});

const app = new Vue({
    components: {
        CountrySelectorFull,
        'v-header': Header,
        'v-footer': Footer,
    },
    data() {
        return {
            win_width: $(window).width(),
            is_iOS: /iPad|iPhone|iPod/.test(navigator.userAgent),
            routerTransitionData: {
                name: 'fade',
                mode: 'out-in',
            },
            routerTransitionAfterEnter: function (el) {
                window.scrollTo(0, 1);
                window.scrollTo(0, 0);
            },
            countries,
            popularCountries: [0, 1, 2], //indexul celor mai populare din "countries"
            selectedCountry: {},
            zones: countriesZone,
            services: [
                {
                    name: 'Abonament',
                    name_short: 'Abonament',
                    url: 'abonament',
                    title: 'abonamente',
                },
                {
                    name: 'Cartela Vodafone',
                    name_short: 'Cartelă',
                    url: 'cartela',
                    title: 'cartelă',
                },
                {
                    name: "Internet pentru <br class='visible-xs'> laptop și tabletă",
                    name_short: 'Internet',
                    url: 'internet',
                    title: 'pentru laptop și tabletă',
                },
            ],
            serviceActive: {},
            travelTimes: [
                {
                    name: 'Înainte de călătorie',
                    url: 'inainte-de-calatorie',
                },
                {
                    name: 'În timpul călătoriei',
                    url: 'in-timpul-calatoriei',
                },
                {
                    name: 'După călătorie',
                    url: 'dupa-calatorie',
                },
            ],
            travelTimeActive: null,
            questions,
            travelTips,
            loaded: 1,
        };
    },
    router,
    computed: {
        questionsVisible() {
            return questions.slice(0, 10 * this.loaded);
        },
        is_mobile() {
            return this.win_width < 768;
        },
        hrefAbonament() {
            return this.$root.is_mobile ? 'https://www.vodafone.ro/personal/servicii-si-tarife/abonamente/toate-abonamentele/index.htm' : 'https://www.vodafone.ro/personal/servicii-si-tarife/abonamente/toate-abonamentele/index.htm';
        },
        hrefActivate() {
            return this.$root.is_mobile ? 'https://www.vodafone.ro/vfrointegration/appmanager/vfroportal/cartela?_nfpb=true&_pageLabel=OCS_Promotii_Page' : 'https://www.vodafone.ro/vfrointegration/appmanager/vfroportal/cartela?_nfpb=true&_pageLabel=OCS_Promotii_Page';
        },
    },
    watch: {
        $route(to, from) {},
    },
    methods: {
        goToStep: function (step) {
            if (step == 0) {
            } else if (step == 1) {
                this.breadcrumbStep = 1;
            }
        },
    },
    mounted() {
        $('.app-loader').removeClass('is-visible');
        $(window).resize(() => {
            var win_width = $(window).width();
            if (win_width !== this.win_width) {
                this.win_width = win_width;
            }
        });
    },
}).$mount('#app');
